import { PropsWithChildren, useCallback, useEffect } from 'react'
import { styled } from 'styled-components'
import { ScreenQuery } from '../../utilities'

export const DESKTOP_OVERLAY_HORIZONTAL_PADDING = 150
export const DESKTOP_OVERLAY_VERTICAL_PADDING = 100

export const MOBILE_OVERLAY_HORIZONTAL_PADDING = 20
export const MOBILE_OVERLAY_VERTICAL_PADDING = 50

export const TABLET_OVERLAY_HORIZONTAL_PADDING = 80
export const TABLET_OVERLAY_VERTICAL_PADDING = 80

const OverlayBackground = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
`
const OverlayContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.primary.mainContrast};
  position: fixed;

  inset: ${DESKTOP_OVERLAY_VERTICAL_PADDING}px
    ${DESKTOP_OVERLAY_HORIZONTAL_PADDING}px;
  ${ScreenQuery.mobile} {
    inset: ${MOBILE_OVERLAY_VERTICAL_PADDING}px
      ${MOBILE_OVERLAY_HORIZONTAL_PADDING}px;
  }
  ${ScreenQuery.tablet} {
    inset: ${TABLET_OVERLAY_VERTICAL_PADDING}px
      ${TABLET_OVERLAY_HORIZONTAL_PADDING}px;
  }
  overflow: hidden;
  z-index: 101;
`

type Props = { onClose: () => void; className?: string } & PropsWithChildren
export function Overlay({ children, onClose, className }: Props) {
  // Prevent background scrolling when the overlay is open
  useEffect(() => {
    // Store the original overflow style
    const originalOverflow = document.body.style.overflow
    // Prevent scrolling on the body
    document.body.style.overflow = 'hidden'
    // Cleanup function to restore the original overflow when component unmounts
    return () => {
      document.body.style.overflow = originalOverflow
    }
  }, [])
  const stopPropagationHandler = useCallback((e: React.MouseEvent) => {
    e.stopPropagation()
  }, [])
  return (
    <>
      <OverlayBackground onClick={onClose} />
      <div>
        <OverlayContainer
          onClick={stopPropagationHandler}
          className={className}
        >
          {children}
        </OverlayContainer>
      </div>
    </>
  )
}

export default Overlay
